
























































































































































































































import { fetchMID } from './fetchMID';
import DatePicker from '@/reusable/Form/DatePicker.vue';
import Vue from 'vue';
import { AxiosVue } from '@/AxiosVue'; //
import { ServicioProxy } from '@/config/enums'; //
import { Component, Prop, Emit, Watch } from 'vue-property-decorator';
import { LoadingService } from '@/services/loadingService';
import { EstadoEntidad } from '@/config/enums';
import { Funcionalidades } from '@/config/funcionalidades';
const { AgGridVue } = require('ag-grid-vue');
import Confirmation from '@/components/Confirmation.vue'; //
import store from '@/store';
import {
  GridOptions,
  GridApi,
  ColumnApi,
  ColDef,
  GridReadyEvent,
  RowNode,
  CellContextMenuEvent,
} from 'ag-grid-community';

@Component({
  components: {
    DatePicker,
    'app-confirmacion': Confirmation,
    GridComponent: AgGridVue,
  },
})
export default class FormEditarAsignacionVehiculos extends Vue {
  [x: string]: any;
  @Prop({}) edited: any;
  @Prop({ default: false }) esEdicion!: boolean;
  @Prop({ required: true }) clienteId: any;
  @Prop({
    default: () => ({ id: 0, nombre: '', estado: EstadoEntidad.Activo }),
  })
  @Prop({})
  endPoints!: any;
  accion!: any;
  ordesList2: any;
  data: any = {};
  selectedItem: any = 'Vehiculos';
  headersFlotas: any = [
    { text: 'Flota', value: 'flota', width: '500', sortable: true },
    {
      text: 'Plataforma',
      value: 'plataforma',
      sortable: true,
    } /*
    { text: 'Todos', value: '__id_cliente' }, */,
  ];
  headersVehiculos: any = [
    { text: 'Flota', value: 'flota', width: '300', sortable: true },
    { text: 'Patente', value: 'patente', sortable: true },
    { text: 'Plataforma', value: 'plataforma', sortable: true },
    { text: 'Última Actividad', value: 'ultimo_evento_gps', sortable: true },
  ];
  itemsFlotas: any = [];
  codeVehiculo: string = '';
  patente: string = '';
  itemsVehiculos: any = [];
  gridOptions: GridOptions;
  columnDefs: Array<ColDef> = [];
  gridApi: GridApi;
  columnApi: ColumnApi;
  localeText: any = {};
  serverSide: any;
  itemsVehiculosAsignados: any = [];
  itemsFlotasAsignadas: any = [];
  itemsDeselecteFlotas: any = [];
  itemsDeselectedVehiculos: any = [];
  newVehiculos: any = [];
  newFlotas: any = [];
  interval: any;
  searchGrid: string = '';
  selectAllChecked: boolean = false;
  pagination: any = {
    rowsPerPage: 'Todos',
  };
  rowsPerPage: any = [5, 10, 25, { text: 'Todos', value: -1 }];
  paginationV: any = {
    rowsPerPageV: 'Todos',
  };
  rowsPerPageV: any = [{ text: 'Todos', value: -1 }];
  selected: any[] = [];
  selectedFlotas: any[] = [];
  rules = {
    required: (value: any) => !!value || 'Required.',
    counter: (value: any) => value.length <= 15 || 'Maximo 15 caracteres',
    soloLetras: (value: any) => {
      return value.match(/^[a-zA-Z]*$/) || 'Solo se permiten letras';
    },
    email: (value: any) => {
      if (value != '') {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(value) || 'Invalid e-mail.';
      }
    },
  };
  nombre_ws: any = '';

  constructor() {
    super();

    this.columnDefs = [
      {
        minWidth: 70,
        width: 75,
        field: '',
        checkboxSelection: true,
        headerCheckboxSelection: true,
        cellRenderer: (r: any) => {
          if (r.hasOwnProperty('data') && r.data.checked !== undefined) {
            return r.node.setSelected(r.data.checked);
          }
        },
      },
      {
        headerName: 'Flota',
        field: 'flota',
        sortable: true,
        resizable: true,
        minWidth: 80,
        lockPinned: true,
      },
      {
        headerName: 'Patente',
        field: 'patente',
        sortable: true,
        resizable: true,
        minWidth: 80,
        lockPinned: true,
      },
      {
        headerName: 'Plataforma',
        field: 'plataforma',
        sortable: true,
        resizable: true,
        minWidth: 80,
        lockPinned: true,
      },
      {
        headerName: 'Última Actividad',
        field: 'fechaModificacion',
        sortable: true,
        resizable: true,
        width: 80,
        lockPinned: true,
      },
    ];

    this.gridOptions = {
      rowSelection: 'multiple',
      pagination: true,
      paginationPageSize: 50, //Solución Paginación
      cacheBlockSize: 50, //Solución Paginación //Ordenamiento + Seleccion
      paginationAutoPageSize: false,
      suppressRowClickSelection: true,
      suppressCellSelection: false,
      localeText: this.localeText,
      onGridReady: this.onGridReady,

      rowModelType: 'serverSide',
      serverSideDatasource: this.serverSide,

      columnDefs: this.columnDefs,
      suppressCopyRowsToClipboard: true,
      onGridSizeChanged: event => {
        event.api.sizeColumnsToFit();
      },
      overlayNoRowsTemplate: 'No hay filas para mostrar',
      alwaysShowVerticalScroll: false,
      onRowSelected: this.onSelectionRow,
      isExternalFilterPresent: this.isExternalFilterPresent,
      doesExternalFilterPass: this.doesExternalFilterPass,
      blockLoadDebounceMillis: 350,
      columnTypes: {},
      suppressCsvExport: true,
      suppressExcelExport: true,
    };
  }

  async getInfoGrid() {
    let selectedRows: any[] = [];
    let unselectedRows: any[] = [];
    this.gridApi.forEachNode((node: any) => {
      if (node.isSelected()) {
        selectedRows.push(node.data);
      } else {
        unselectedRows.push(node.data);
      }
    });
    // Filtrar a los que se han seleccionado y deseleccionado
    selectedRows = selectedRows.filter(
      (selected: any) => selected.asignado == 0
    );
    unselectedRows = unselectedRows.filter(
      (selected: any) => selected.asignado == 1
    );
    return { selected: selectedRows, unselected: unselectedRows };
  }

  onFilterTextBoxChanged() {
    clearInterval(this.interval);
    const self = this;
    this.interval = setInterval(function() {
      if (self.searchGrid.length >= 2) {
        self.gridApi.onFilterChanged();
      } else if (self.searchGrid.length === 0) {
        self.gridApi.setServerSideDatasource(self.serverSide);
      }
      clearInterval(self.interval);
    }, 500);
  }

  async onGridReady(params: GridReadyEvent) {
    this.gridApi = params.api;
    this.columnApi = params.columnApi;
    var self = this;

    this.serverSide = {
      getRows(params: any): void {
        params.request.paginationSize = self.gridOptions.cacheBlockSize;
        params.request.search = self.searchGrid;
        self.loadingService.showLoading();

        self.itemsVehiculos = [];
        self.itemsVehiculosAsignados = [];
        self.selected = [];

        fetchMID(
          {
            ...params.request,
            clienteid: self.clienteId.toString(),
            id: self.edited,
          },
          'mid_cliente/GetVehiculosAsignados'
        )
          .then((data: any) => data.data)
          .then((data: any) => {
            if (data.CODIGO_RESPUESTA == '1') {
              data.data.forEach((e: any) => {
                const asignado = parseInt(e.asignado);
                const checked = asignado == 1;
                const flota = e.flota;
                const patente = e.patente;
                const plataforma = e.plataforma;
                const fechaModificacion = e.ultimo_evento_gps;
                const id = e.id;
                const flotaId = e.flotaid;
                self.itemsVehiculos.push({
                  id,
                  flotaId,
                  flota,
                  patente,
                  plataforma,
                  fechaModificacion,
                  asignado,
                  checked,
                });
                if (asignado == 1) {
                  self.itemsVehiculosAsignados.push(e.id);
                  self.selected.push(e.id);
                }
              });

              if (self.itemsVehiculos.length == 0) {
                params.successCallback([{}], 0);
                self.gridApi.showNoRowsOverlay();
              } else {
                params.successCallback(self.itemsVehiculos, data.total);
                self.gridApi.hideOverlay();
              }

              self.gridApi.hideOverlay();
            } else {
              self.$snotify.error(data.MENSAJE_RESPUESTA, {
                timeout: 3000,
              });
              self.gridApi.showNoRowsOverlay();
              self.gridApi.hideOverlay();
            }
          })
          .catch((error: any) => {
            self.$snotify.error('Ocurrió un error', { timeout: 3000 });
            console.log(error);
          })
          .finally(() => {
            self.loadingService.hideLoading();
            return null;
          });
      },
    };
    // this.gridApi.setRowData([]);
    this.gridApi.setDomLayout('autoHeight');
    this.gridApi.setServerSideDatasource(this.serverSide);
  }

  onSelectionRow(event: any) {
    event.data.checked = event.node.isSelected();
  }

  selectedRadio(e: any) {
    switch (e) {
      case 'Flotas':
        this.selectedItem = 'Flotas';
        break;
      case 'Vehiculos':
        this.selectedItem = 'Vehiculos';
        break;
    }
  }

  toggleSelectionVehiculo(id: number) {
    const indexSelected = this.selected.indexOf(id.toString());
    if (indexSelected === -1) {
      this.selected.push(id.toString());
    } else {
      // Eliminar el id si ya está en el array
      this.selected.splice(indexSelected, 1);
    }
    if (this.itemsVehiculosAsignados.includes(id.toString())) {
      if (indexSelected === -1) {
        this.itemsDeselectedVehiculos.push(id.toString());
      } else {
        this.itemsDeselectedVehiculos = this.itemsDeselectedVehiculos.filter(
          (item: number) => item !== id
        );
      }
    } else {
      if (indexSelected === -1) {
        this.newVehiculos.push(id.toString());
      } else {
        this.newVehiculos = this.newVehiculos.filter(
          (item: number) => item !== id
        );
      }
    }
  }

  selectAllVehiculos() {
    this.selectAllChecked = !this.selectAllChecked;
    // Agregar todos los IDs de los vehículos a la lista de vehículos seleccionados
    this.itemsVehiculos.forEach(
      async (vehiculo: { asignado: any; id: number }) => {
        vehiculo.asignado = this.selectAllChecked;
        // Llama a la función para agregar o quitar vehículos seleccionados de la lista
        await this.toggleSelectionVehiculo(vehiculo.id);
      }
    );
  }

  isSelectedFlota(id: number) {
    return this.itemsFlotasAsignadas.includes(id.toString());
  }

  toggleSelectionFlota(id: number) {
    const indexSelected = this.selectedFlotas.indexOf(id.toString());
    if (indexSelected === -1) {
      this.selectedFlotas.push(id.toString());
    } else {
      // Eliminar el id si ya está en el array
      this.selectedFlotas.splice(indexSelected, 1);
    }
    if (this.itemsFlotasAsignadas.includes(id.toString())) {
      if (indexSelected === -1) {
        this.itemsDeselecteFlotas = this.itemsDeselecteFlotas.filter(
          (item: number) => item !== id
        );
        const vehiculosConFlotaDeseleccionadaBD = this.itemsVehiculos.filter(
          (vehiculo: { flotaId: number }) => vehiculo.flotaId === id
        );
        // Almacenar los ids de los vehículos encontrados
        const idsVehiculosConFlotaDeseleccionadaBD = vehiculosConFlotaDeseleccionadaBD.map(
          (vehiculo: { id: any }) => vehiculo.id
        );

        this.idsVehiculosConFlotaSeleccionadaBD = this.idsVehiculosConFlotaSeleccionadaBD.filter(
          (item: any) => !idsVehiculosConFlotaDeseleccionadaBD.includes(item)
        );
      } else {
        this.itemsDeselecteFlotas.push(id);
        const vehiculosConFlotaSeleccionadaBD = this.itemsVehiculos.filter(
          (vehiculo: { flotaId: number }) => vehiculo.flotaId === id
        );
        // Almacenar los ids de los vehículos encontrados
        const idsVehiculosConFlotaSeleccionadaBD = vehiculosConFlotaSeleccionadaBD.map(
          (vehiculo: { id: any }) => vehiculo.id
        );
        // Guardar los ids de los vehículos en algún lugar (por ejemplo, en una variable)
        this.idsVehiculosConFlotaSeleccionadaBD = idsVehiculosConFlotaSeleccionadaBD;
      }
    } else {
      if (indexSelected === -1) {
        this.newFlotas.push(id);
        // Realizar la búsqueda de vehículos con la flota seleccionada
        const vehiculosConFlotaSeleccionada = this.itemsVehiculos.filter(
          (vehiculo: { flotaId: number }) => vehiculo.flotaId === id
        );
        // Almacenar los ids de los vehículos encontrados
        const idsVehiculosConFlotaSeleccionada = vehiculosConFlotaSeleccionada.map(
          (vehiculo: { id: any }) => vehiculo.id
        );
        // Guardar los ids de los vehículos en algún lugar (por ejemplo, en una variable)
        this.idsVehiculosConFlotaSeleccionada = idsVehiculosConFlotaSeleccionada;
      } else {
        this.newFlotas = this.newFlotas.filter((item: number) => item !== id);
        const vehiculosConFlotaDeseleccionada = this.itemsVehiculos.filter(
          (vehiculo: { flotaId: number }) => vehiculo.flotaId === id
        );
        // Almacenar los ids de los vehículos encontrados
        const idsVehiculosConFlotaDeseleccionada = vehiculosConFlotaDeseleccionada.map(
          (vehiculo: { id: any }) => vehiculo.id
        );

        this.idsVehiculosConFlotaSeleccionada = this.idsVehiculosConFlotaSeleccionada.filter(
          (item: any) => !idsVehiculosConFlotaDeseleccionada.includes(item)
        );
      }
    }
  }

  async getFlotas() {
    let self = this;
    this.loadingService.showLoading();
    return fetchMID(
      { clienteid: this.clienteId.toString() },
      'mid_cliente/GetFlotasPorCliente'
    )
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          this.itemsFlotas = data.data.data.filter(
            (item: { flotaid: string; flota: string }) =>
              item.flota.trim() !== ''
          );
          return data.data.data;
        } else {
          self.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
        }
      })
      .catch((error: any) => {
        self.$snotify.error('Ocurrió un error', { timeout: 3000 });
      })
      .finally(() => {
        this.loadingService.hideLoading();
        return null;
      });
  }

  async getVehiculosAsignados() {
    let self = this;
    this.loadingService.showLoading();
    return fetchMID(
      { clienteid: this.clienteId.toString(), id: this.edited },
      'mid_cliente/GetVehiculosAsignados'
    )
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          data.data.data.forEach((e: any) => {
            const asignado = parseInt(e.asignado);
            const flota = e.flota;
            const patente = e.patente;
            const plataforma = e.plataforma;
            const fechaModificacion = e.ultimo_evento_gps;
            const id = e.id;
            const flotaId = e.flotaid;
            this.itemsVehiculos.push({
              id,
              flotaId,
              flota,
              patente,
              plataforma,
              fechaModificacion,
              asignado,
            });
            if (asignado == 1) {
              this.itemsVehiculosAsignados.push(e.id);
              this.selected.push(e.id);
            }
          });

          return data.data.data;
        } else {
          self.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
        }
      })
      .catch((error: any) => {
        self.$snotify.error('Ocurrió un error', { timeout: 3000 });
      })
      .finally(() => {
        this.loadingService.hideLoading();
        return null;
      });
  }

  async getFlotasAsignados() {
    let self = this;
    this.loadingService.showLoading();
    return fetchMID(
      { clienteid: this.clienteId.toString(), id: this.edited },
      'mid_cliente/GetFlotasAsignadas'
    )
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          data.data.data.forEach((e: any) => {
            this.itemsFlotasAsignadas.push(e.cod_flota);
            this.selectedFlotas.push(e.cod_flota);
          });
          return data.data.data;
        } else {
          self.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
        }
      })
      .catch((error: any) => {
        self.$snotify.error('Ocurrió un error', { timeout: 3000 });
      })
      .finally(() => {
        this.loadingService.hideLoading();
        return null;
      });
  }

  async mounted() {
    /* await this.getFlotas();
    await this.getFlotasAsignados(); */
    const filteredEndPoints = this.endPoints.filter(
      (endpoint: { id: any }) => endpoint.id === this.edited.toString()
    );
    if (filteredEndPoints.length > 0) {
      // Si hay elementos, asignar el valor de nombre_ws
      this.nombre_ws = filteredEndPoints[0].nombre_ws;
    }
  }

  onModelUpdated() {}

  onSelectionChanged(id: any) {
    this.isSelectedFlota(id.toString());
    this.isSelectedVehiculo(id.toString());
  }

  //abstract
  readonly funcionalidad: Funcionalidades =
    Funcionalidades.TablaMantenedorProveedores;

  //propiedades globales
  loadingService = new LoadingService();
  $snotify: any;
  dialog: boolean = true;
  dialogConfirmacionClose: boolean = false;
  bottomNav: any = '1';
  dictionaryFormErrors: any = {};
  validForm: boolean = false;
  dialogConfirmacion: boolean = false;
  btnBloquear: Boolean = false;

  //Interface
  estadoSwitch: boolean = false;

  //controllers
  readonly controller: string = 'funcionalidad';
  readonly controllerAccion: string = 'accion';
  readonly controllerModuloAccion: string = 'moduloaccion';
  axios: AxiosVue = new AxiosVue(ServicioProxy.GestionUsuario);

  //@Watch('show')
  async onPropertyChanged(value: boolean) {
    this.dialog = value;
    this.dialog = value;
    // permisos
    this.setBotonNav();
  }

  datoEditado: any = {};

  async grabarEdicion() {
    let infoGrid: any = await this.getInfoGrid();
    this.itemsDeselectedVehiculos = infoGrid.unselected.map(
      (data: any) => data.id
    );
    this.newVehiculos = infoGrid.selected.map((data: any) => data.id);
    // console.log("Vehiculos deseleccionados: ",this.itemsDeselectedVehiculos);
    // console.log("Vehiculos seleccionados: ", this.newVehiculos);
    if (
      this.itemsDeselecteFlotas.length > 0 ||
      this.itemsDeselectedVehiculos.length > 0
    ) {
      this.quitar();
    }
    if (this.newFlotas.length > 0 || this.newVehiculos.length > 0) {
      this.insertar();
    }
  }

  async quitar() {
    let self = this;
    this.loadingService.showLoading();
    return fetchMID(
      {
        clienteid: this.clienteId.toString(),
        vehiculos:
          this.itemsDeselectedVehiculos.length > 0
            ? this.itemsDeselectedVehiculos
            : '' && this.idsVehiculosConFlotaSeleccionadaBD.length > 0
            ? this.idsVehiculosConFlotaSeleccionadaBD
            : '',
        flotas: this.itemsDeselecteFlotas,
        id: this.edited.toString(),
        userid: store.state.userId.toString(),
      },
      'mid_cliente/PostQuitaRelacionVehiculo'
    )
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          self.$snotify.success('Eliminación exitosa', { timeout: 3000 });
          this.closeModal(false);
        } else {
          self.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
        }
      })
      .finally(() => {
        self.loadingService.hideLoading();
      });
  }

  async insertar() {
    let self = this;
    this.loadingService.showLoading();
    return fetchMID(
      {
        clienteid: this.clienteId.toString(),
        vehiculos:
          this.newVehiculos.length > 0
            ? this.newVehiculos
            : '' && this.idsVehiculosConFlotaSeleccionada.length > 0
            ? this.idsVehiculosConFlotaSeleccionada
            : '',
        flotas: this.newFlotas,
        id: this.edited.toString(),
        userid: store.state.userId.toString(),
      },
      'mid_cliente/PostInserteRelacionVehiculo'
    )
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          self.$snotify.success('Actualizacion exitosa', { timeout: 3000 });
          this.closeModal(false);
        } else {
          self.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
        }
      })
      .finally(() => {
        self.loadingService.hideLoading();
        return null;
      });
  }
  setBotonNav() {
    var accion = 'Editar';
    var evaluado = false;

    if (!this.esEdicion) {
      accion = 'Ver Detalle';
    }
  }

  cierraMenu() {
    var appBanners = document.getElementsByClassName(
      'ag-menu'
    ) as HTMLCollectionOf<HTMLElement>;
    if (appBanners.length > 0) {
      appBanners[0].remove();
    }
  }

  closeModal(val: boolean) {
    this.$validator.reset();
    document.getElementById('cardDivTV').scrollIntoView(true);
    this.$emit('modalAsociacionEmit', false);
    this.$emit('datoEditado', true);
    this.dialog = false;
    this.btnBloquear = false;
  }

  confirmCallback(val: any) {}

  confirmCallbackConfirm(val: boolean) {
    this.dialogConfirmacionClose = false;
    if (val) {
      this.closeModal(false);
    }
  }
}
